module.exports = __webpack_public_path__ + "img/cns_email_android5.a444eff6.png";